import { configureStore } from "@reduxjs/toolkit";
import global, { IGlobalStore } from "./global";

export default configureStore({
  reducer: {
    global,
  },
});
declare module "react-redux" {
  interface DefaultRootState {
    global: IGlobalStore;
  }
}
